<script lang="ts">
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import { CartOrderEntity, ProductEntity } from "@shared/services/event_tracking/entities";
  import type { RecentlyRemovedProduct } from "@retailer/stores/RecentlyRemovedProductStore";

  export let product: RecentlyRemovedProduct;
</script>

<div
  class="fizz-inset-square-32 fizz-flex-row-0 fizz-full-width fizz-text-medium fizz-surface-gray"
>
  <p>
    <UIRouterLink
      stateName="layout.product_detail"
      classes="fizz-text-strong"
      params={{ productId: product.productLineId }}
      eventName="cart_product_redirect"
      useTrackClick
      trackingParams={[
        new CartOrderEntity({ distributorId: product.distributorId, orderId: product.orderId }),
        new ProductEntity({ productId: product.id }),
      ]}
    >
      {product.productLineName}
    </UIRouterLink>
    <span class="fizz-text-subdued">was removed from your order.</span>
  </p>
</div>
